import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const RegenerateTuitionInvoicesMutation = graphql.persisted(
  "RegenerateTuitionInvoices",
  graphql(`
    mutation RegenerateTuitionInvoices($input: RegenerateTuitionInvoicesInput!) {
      regenerateTuitionInvoices(input: $input) {
        familyEnrollment {
          id state paymentScheduleType billingDayOfMonth
          invoices { id key status amountCents dueDate memo lineItems { id description amountCents lineType } }
        }
        userErrors { message path }
      }
    }
  `)
);

export { RegenerateTuitionInvoicesMutation };

export function useRegenerateTuitionInvoices() {
  return useMutation(RegenerateTuitionInvoicesMutation);
}
